module.exports = __webpack_public_path__ + "static/media/006.c5db4390.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/006.jpg
// module id = 550
// module chunks = 0